/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

import './src/styles/global.css';

function onRouteUpdate(args) {
  // Not getting anything out of this
  // for now, so turn it off.
  // if (window.analytics) {
  //   const { location } = args;
  //   if (location) {
  //     window.analytics.page()
  //   }
  // }

  const zendeskKey = process.env.ZENDESK_API_KEY

  if (!zendeskKey) {
    return
  }

  const scriptTag = document.getElementById("ze-snippet")
  const pathname = args.location.pathname
  const zendeskPath = pathname === "/support_chat" || pathname === "/support_chat/"

  if (scriptTag && zendeskPath) {
    return
  }

  // For now we only want to render the zendesk chat widget on a specific page
  // so we can control how many people use it
  if (zendeskPath) {
    var zendeskScript = document.createElement('script');
    zendeskScript.setAttribute('id', `ze-snippet`);
    zendeskScript.setAttribute('src', `https://static.zdassets.com/ekr/snippet.js?key=${process.env.ZENDESK_API_KEY}`);
    document.body.append(zendeskScript)
    return
  }
}

export { onRouteUpdate }
